import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import PagesHeader from 'components/Header/PagesHeader.jsx';
import StandardSnackbar from 'components/StandardSnackbar';
import pagesRoutes from 'routes/pages.jsx';
import pagesStyle from 'assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx';
import { hideError } from 'store/actions/errorActions';


class Pages extends React.Component {
  componentDidMount() {
    document.body.style.overflow = 'unset';
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <PagesHeader {...rest} />
        <div className={classes.wrapper} ref="wrapper">
          <div
            className={classes.fullPage}
            style={{ backgroundColor: '#FFFFFF' }}
          >
            <Switch>
              {pagesRoutes.map((prop, key) => {
                if (prop.collapse) {
                  return null;
                }
                if (prop.redirect) {
                  return (
                    <Redirect from={prop.path} to={prop.pathTo} key={key} />
                  );
                }
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
          </div>
        </div>
        <StandardSnackbar 
          body={() => (
            <p style={{ color: 'red', fontSize: '18px' }}>
              {this.props.error}
            </p>
          )}
          open={!!this.props.error} 
          handleClose={this.props.hideError}
        />
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({error}) => {
  return { error };
};

export default compose(
  connect(mapStateToProps, { hideError }),
  withStyles(pagesStyle)
)(Pages);
